// src/modules/assetManagement/useAssetFilterOptions.ts
// Options for the Event / Product / Tag filters. With events picked, products narrow to those events' products.
import { assetApi } from "./assetApi";
import type { FilterOption } from "./components/MultiSelectFilter";
import { productIdsOfEvents } from "./linkRules";
import { useAssetQuery } from "./useAssetQuery";

export const useAssetFilterOptions = (selectedEventIds: string[], selectedProductIds: string[]) => {
  const { data: events = [] } = useAssetQuery(() => assetApi.listEvents(), []);
  const { data: products = [] } = useAssetQuery(() => assetApi.listProducts(), []);
  const { data: tags = [] } = useAssetQuery(() => assetApi.listTags(), []);

  const allowed = selectedEventIds.length ? productIdsOfEvents(events, selectedEventIds) : null;

  const eventOptions: FilterOption[] = events.map((e) => ({ value: e.id, label: e.title }));
  const productOptions: FilterOption[] = products
    .filter((p) => !allowed || allowed.has(p.id) || selectedProductIds.includes(p.id))
    .map((p) => {
      const inEvents = events.filter((e) => e.productIds.includes(p.id)).map((e) => e.title);
      return { value: p.id, label: p.title, meta: inEvents.length ? `In ${inEvents.join(", ")}` : undefined };
    });
  const tagOptions: FilterOption[] = tags.map((t) => ({ value: t, label: `#${t}` }));

  return {
    events,
    products,
    eventOptions,
    productOptions,
    tagOptions,
    productNote: allowed ? "Showing products in the selected events" : undefined,
  };
};